export default __webpack_public_path__ + "static/media/hessen_light.b3585c42.png";